export default {
    name: "caseList",
    props: ['data']
};
